import { render, staticRenderFns } from "./NotificationViewOptimization.vue?vue&type=template&id=944223d6"
import script from "./NotificationViewOptimization.vue?vue&type=script&lang=js"
export * from "./NotificationViewOptimization.vue?vue&type=script&lang=js"
import style0 from "./NotificationViewOptimization.vue?vue&type=style&index=0&id=944223d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports